import { render, staticRenderFns } from "./BaseStatusBadge.vue?vue&type=template&id=19e94418"
import script from "./BaseStatusBadge.vue?vue&type=script&lang=js"
export * from "./BaseStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./BaseStatusBadge.vue?vue&type=style&index=0&id=19e94418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports